module.exports = __webpack_public_path__ + "media/images/home/cover-mobile-77c12b72ba722430a01981703828e79c.jpg";